import merge from 'lodash/merge.js';

import Note from '@/store/modules/base/BaseNote.js';
import Collection from '@/store/quill/Collection.js';

export default function ({ name }) {
    return merge(Collection(name, Note), {
        state: {},

        getters: {},

        actions: {},
    });
}
